import { FormalityStatus } from '@enums/formality-status.enum';

export interface LegalAnnualJson {
  formality_status?: FormalityStatus;
  profit_allocation_updated_at?: string;
  amount_affect?: number;
  report_debit_affect?: number;
  report_credit_affect?: number;
  dividend_distribution?: number;
  legal_reserve_amount_affect?: number;
  optional_reserve_amount_affect?: number;
  ago_date?: string;
}

export class LegalAnnual {
  constructor(
    public formalityStatus?: FormalityStatus,
    public profitAllocationUpdatedAt?: string,
    public amountAffect?: number,
    public reportDebitAffect?: number,
    public reportCreditAffect?: number,
    public dividendDistribution?: number,
    public legalReserveAmountAffect?: number,
    public optionalReserveAmountAffect?: number,
    public agoDate?: string
  ) {}

  static fromJson(json: LegalAnnualJson): LegalAnnual {
    return new LegalAnnual(
      json.formality_status,
      json.profit_allocation_updated_at,
      json.amount_affect,
      json.report_debit_affect,
      json.report_credit_affect,
      json.dividend_distribution,
      json.legal_reserve_amount_affect,
      json.optional_reserve_amount_affect,
      json.ago_date
    );
  }
}
